import { render, staticRenderFns } from "./diveCommentList.vue?vue&type=template&id=1f59e4e7&scoped=true&"
import script from "./diveCommentList.vue?vue&type=script&lang=js&"
export * from "./diveCommentList.vue?vue&type=script&lang=js&"
import style0 from "./diveCommentList.vue?vue&type=style&index=0&id=1f59e4e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59e4e7",
  null
  
)

export default component.exports